// Simple in-memory event bus (no Pinia)
function createBus() {
	let seq = 0
	const channels = new Map() // channel -> Map(subId, handler)

	function on(channel, handler) {
		if (!channel || typeof handler !== "function") return () => {}
		const bucket = channels.get(channel) || new Map()
		const id = `s${++seq}`
		bucket.set(id, handler)
		channels.set(channel, bucket)
		// console.log(id)
		let active = true
		return () => {
			if (!active) return
			active = false
			const b = channels.get(channel)
			if (!b) return
			b.delete(id)
			if (b.size === 0) channels.delete(channel)
			// console.log(`Unsubscribed: ${id} from channel: ${channel}`)
		}
	}

	function once(channel, handler) {
		const off = on(channel, (e) => {
			try {
				handler(e)
			} finally {
				off()
			}
		})
		return off
	}

	function emit(channel, event) {
		const bucket = channels.get(channel)
		if (!bucket || bucket.size === 0) return
		const handlers = Array.from(bucket.values())
		for (const fn of handlers) {
			try {
				fn(event, channel)
			} catch (_) {}
		}
	}

	function broadcast(event) {
		for (const [channel, bucket] of channels) {
			const handlers = Array.from(bucket.values())
			for (const fn of handlers) {
				try {
					fn(event, channel)
				} catch (_) {}
			}
		}
	}

	function clearChannel(channel) {
		channels.delete(channel)
	}
	function clearAll() {
		channels.clear()
	}

	return { on, once, emit, broadcast, clearChannel, clearAll }
}

// Persist across HMR in dev (optional)
const bus =
	typeof window !== "undefined"
		? (window.__GV_EVENT_BUS__ ||= createBus())
		: createBus()

export default bus
